import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SectionHeader from '../../../components/sectionHeader';
import Button from '../../../components/button/button';
import icon from '../../../icons/Non_Airfield_WorkOrder.png';
import styles from '../../Maintenance/inspections.module.scss';
import Table from './components/Table';
import { fetchUserProfile } from '../../authentication/redux/actions';
import { clearAction, getGrossReciepts } from '../redux/actions';
import Paginator from '../../../components/paginator/paginator';
import { GROSSRECIEPTS } from '../../../constants/RouterConstants';

class GrossRecieptList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1
    };
  }

  componentDidMount() {
    const { actionFetchGrossReciepts, actionFetchUser, actionClear } = this.props;
    actionFetchUser();
    actionClear();
    actionFetchGrossReciepts();
  }

  changePage = (e) => {
    const { actionFetchGrossReciepts } = this.props;
      actionFetchGrossReciepts(e);
  };

  handleClick = () => {
    const { history, actionClear } = this.props;
    actionClear();
    history.push('/gross_receipts/start');
  }

  render() {
    const { history, gross_receipts, user } = this.props;
    const { currentPage } = this.state;
    return (
    <>
      <SectionHeader icon={icon} translationID="shortcuts.lease.gross.reciepts" defaultTitle="Usage & Fee Reporting">
        <div className={styles.detailHeader} style={{ position: 'absolute', marginBottom: '10px' }}>
          <Button translationID="gross.reciepts.start.title"
            defaultText="Create Gross Receipt"
            onClick={this.handleClick}
          />
        </div>
      </SectionHeader>
      <div style={{ display: 'flex' }} className={styles.toolbar}>
        <div className={styles.counter}>
          <span className={styles.number}>{gross_receipts?.length}</span><span className={styles.req}>Gross Reciepts</span>
        </div>
      </div>
      <div className={styles.container}>
        { gross_receipts?.results && (
        <Table info={gross_receipts?.results} url={GROSSRECIEPTS} history={history} user={user} />
        )}
         {gross_receipts?.results && Object.keys(gross_receipts.results)?.length > 0 && (
            <Paginator totalRecords={gross_receipts && gross_receipts.count} pageLimit={10}
              pageNeighbours={1} onPageChanged={e => this.changePage(e)} page={currentPage}
            />
          )}
      </div>
    </>
    );
  }
}

GrossRecieptList.propTypes = {
  history: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  gross_receipts: state.grossReciepts.gross_receipts,
  user: state.auth.profile,
  fetchRecieptsAction: state.grossReciepts.fetchRecieptsAction
});

const mapDispatchToProps = dispatch => ({
  actionFetchGrossReciepts: (page) => {
    dispatch(getGrossReciepts(page));
  },
  actionFetchUser: () => {
    dispatch(fetchUserProfile());
  },
  actionClear: () => {
    dispatch(clearAction());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(GrossRecieptList);
